export const RESET_PASSWORD = 'resetPassword';
export const SET_PASSWORD = 'setPassword';
export const SEND_CODE = 'sendCode';
export const VALIDATE_CODE = 'validateCode';
export const RESET_STATE = 'resetState';
